module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mceltis6-09a6dccb7dd5e696de181884c53c886e.jpg";